import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  constructor() { }

  setLocalStorage(key: string, value: string): void {
    sessionStorage.setItem(key, value);
  }

  getLocalStorage(key: string): string {
    return sessionStorage.getItem(key) || '';
  }
}
